import { createStyles } from '@material-ui/core';
import { Colors } from 'bz-core-controls/styles/colours';

const styles = createStyles({
  container: {
    margin: '5px',
    display: 'grid',
    gridAutoRows: 'auto',
    gridRowGap: '5px'
  },
  buttons: {
    marginTop: '5px',
    width: 'max-content',
    justifySelf: 'end'
  }
});

const inProgressStyles = createStyles({
  container: {
    margin: '5px',
    display: 'grid',
    gridAutoRows: 'auto',
    gridRowGap: '5px'
  },
  spinner: {
    justifySelf: 'center'
  },
  buttons: {
    marginTop: '5px',
    justifySelf: 'end'
  },
  header: {
    height: '50px',
    padding: 10,
    fontFamily: 'montserrat',
    backgroundColor: Colors.blueGrey900
  },
  deviceCode: {
    fontWeight: 700,
    fontSize: '2rem'
  },
  textContainer: {
    display: 'grid',
    gridAutoRows: 'auto',
    gridRowGap: '10px',
    justifyItems: 'center'
  },
  clickCountdownContainer: {
    position: 'relative',
    height: '100px',
    width: '100px'
  },
  countdownContainer: {
    height: '100px',
    width: '100px'
  }
});

const errorStyles = createStyles({
  textContainer: {
    display: 'grid',
    gridAutoRows: 'auto',
    gridRowGap: '10px',
    justifyItems: 'center'
  },
  pairingErrorText: {
    color: 'red',
    fontWeight: 700,
    fontSize: '14px'
  },
  countdownContainer: {
    height: '100px',
    width: '100px'
  }
});
export { inProgressStyles, errorStyles };
export default styles;
